import { api } from "@/lib/api";

// ---------- Student ----------
export const getOrCreateHomework = (courseId, chapterId) =>
  api
    .get(`/student/courses/${courseId}/chapters/${chapterId}/homework`)
    .then((r) => r.data);

export const saveHomework = (submissionId, answers) =>
  api.put(`/student/homework/${submissionId}`, { answers }).then((r) => r.data);

export const submitHomework = (submissionId) =>
  api.post(`/student/homework/${submissionId}/submit`).then((r) => r.data);

export const listMyHomework = () =>
  api.get(`/student/homework`).then((r) => r.data);

export const startTest = (courseId, chapterId, sessionId = null) =>
  api
    .post(`/student/courses/${courseId}/chapters/${chapterId}/test/start`, {
      session_id: sessionId,
    })
    .then((r) => r.data);

export const autosaveTest = (attemptId, mcqAnswers, subjectiveAnswers) =>
  api
    .put(`/student/test-attempts/${attemptId}`, {
      mcq_answers: mcqAnswers,
      subjective_answers: subjectiveAnswers,
    })
    .then((r) => r.data);

export const submitTest = (attemptId) =>
  api.post(`/student/test-attempts/${attemptId}/submit`).then((r) => r.data);

export const listMyAttempts = () =>
  api.get(`/student/test-attempts`).then((r) => r.data);

export const getMyAttempt = (attemptId) =>
  api.get(`/student/test-attempts/${attemptId}`).then((r) => r.data);

// ---------- Teacher ----------
export const teacherGradingQueue = () =>
  api.get(`/teacher/grading/queue`).then((r) => r.data);

export const teacherGetHomework = (id) =>
  api.get(`/teacher/homework/${id}`).then((r) => r.data);

export const teacherGradeHomework = (id, body) =>
  api.post(`/teacher/homework/${id}/grade`, body).then((r) => r.data);

export const teacherGetAttempt = (id) =>
  api.get(`/teacher/test-attempts/${id}`).then((r) => r.data);

export const teacherGradeAttempt = (id, body) =>
  api.post(`/teacher/test-attempts/${id}/grade`, body).then((r) => r.data);

// ---------- Admin ----------
export const adminGradingStats = () =>
  api.get(`/admin/grading/stats`).then((r) => r.data);

// ---------- helpers ----------
export const homeworkStatusLabel = (s) =>
  ({ draft: "Draft", submitted: "Submitted", graded: "Graded" })[s] || s;

export const homeworkStatusClass = (s) =>
  ({
    draft: "bg-stone-100 text-stone-700 border-stone-300",
    submitted: "bg-amber-100 text-amber-800 border-amber-300",
    graded: "bg-emerald-100 text-emerald-800 border-emerald-300",
  })[s] || "";

export const testStatusLabel = (s) =>
  ({
    in_progress: "In progress",
    submitted: "Awaiting grading",
    partially_graded: "Partially graded",
    graded: "Graded",
  })[s] || s;

export const testStatusClass = (s) =>
  ({
    in_progress: "bg-blue-100 text-blue-800 border-blue-300",
    submitted: "bg-amber-100 text-amber-800 border-amber-300",
    partially_graded: "bg-amber-100 text-amber-800 border-amber-300",
    graded: "bg-emerald-100 text-emerald-800 border-emerald-300",
  })[s] || "";
